import { supported as lsSupported } from 'bv-local-storage';
import { hasSportsbook } from 'global-config';
import withLazyLoad from 'bv-lazy-load';

import { CenterContent, LocalStorageWarning } from './components';

const RightSidebar = withLazyLoad()('rightSidebar');
const SmartAppBanner = withLazyLoad()('layoutApps.smartAppBanner');
const FloatingNavigation = withLazyLoad()('layoutApps.floatingNavigation');
const LeftComponents = withLazyLoad()('layoutApps.leftComponents');
const ModalHelper = withLazyLoad()('layoutApps.modalHelper');

const LayoutView = () => (
  lsSupported() ? (
    <>
      <SmartAppBanner />
      <LeftComponents />
      {hasSportsbook && <RightSidebar />}
      <CenterContent />
      <FloatingNavigation />
      <ModalHelper />
    </>
  ) : <LocalStorageWarning />
);

export default LayoutView;
